import styled, { css } from 'styled-components';

export const HeaderTool = styled.div`
  ${({ inActivity }) =>
    inActivity === true
      ? css`
          width: 20px;
          height: 20px;
          margin: 2px 0 0 0;
        `
      : css`
          width: 18px;
          height: 18px;
          margin: 0 18px 0 0;
        `}
  opacity: 0.6;
  transition: 0.2s opacity ease-in-out;
  background-repeat: no-repeat;
  display: block;
  cursor: pointer;

  &:hover,
  &:focus {
    opacity: 1;
    transition: 0.2s opacity ease-in-out;
  }

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}
`;
